/**
 * shareContent.js — native Web Share on mobile, in-app ShareModal on desktop.
 */

function buildSharePayload({ title, url, text }) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  return {
    title: title || '',
    url: shareUrl,
    text: text || title || '',
  };
}

/** Native share sheet is reliable on touch / narrow viewports only. */
function isMobileShareContext() {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(pointer: coarse)').matches ||
    window.matchMedia('(max-width: 768px)').matches
  );
}

function canUseNativeShare(payload) {
  if (typeof navigator.share !== 'function') return false;
  if (!isMobileShareContext()) return false;
  if (typeof navigator.canShare === 'function') {
    try {
      return navigator.canShare(payload);
    } catch {
      return false;
    }
  }
  return true;
}

export async function triggerShare({
  title,
  url,
  text,
  openEmailModal,
  showSuccess,
  copiedMessage = 'Link copied to clipboard',
}) {
  // In-app modal supports copy link + email; prefer it whenever the page wires it up.
  if (typeof openEmailModal === 'function') {
    openEmailModal();
    return;
  }

  const payload = buildSharePayload({ title, url, text });

  if (canUseNativeShare(payload)) {
    try {
      await navigator.share(payload);
      return;
    } catch (err) {
      if (err?.name === 'AbortError') return;
      // fall through to clipboard
    }
  }

  if (payload.url && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(payload.url);
      showSuccess?.(copiedMessage);
    } catch {
      /* ignore */
    }
  }
}
